exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faIconUnicode:before {\r\n  /*content: attr(data-before);*/\r\n  font-family: \"Font Awesome 5 Free\";\r\n  margin-right: 5px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/not-found/not-found.component.css
// module id = ../../../../../src/app/shared-module/not-found/not-found.component.css
// module chunks = 5